const DB = "jixxeo-offline";
const STORE = "videos";

function open() {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE, { keyPath: "id" });
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => res(out?.result);
    t.onerror = () => rej(t.error);
  });
}

const absolute = (u) => (!u ? "" : u.startsWith("http") ? u : process.env.REACT_APP_BACKEND_URL + u);

async function fetchBlob(url, onProgress) {
  const resp = await fetch(absolute(url), { credentials: "include" });
  if (!resp.ok) throw new Error(`Download failed (${resp.status})`);
  const total = Number(resp.headers.get("content-length")) || 0;
  if (!resp.body || !total) return resp.blob();
  const reader = resp.body.getReader();
  const chunks = []; let got = 0;
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value); got += value.length;
    onProgress?.(Math.round((got / total) * 100));
  }
  return new Blob(chunks, { type: resp.headers.get("content-type") || "video/mp4" });
}

export async function saveOffline(v, onProgress, quality = "full", url = v.video_url) {
  const blob = await fetchBlob(url, onProgress);
  const thumb = v.thumbnail_url ? await fetchBlob(v.thumbnail_url).catch(() => null) : null;
  const meta = { id: v.id, title: v.title, description: v.description, creator: v.creator,
                 category: v.category, duration: v.duration, saved_at: new Date().toISOString(), size: blob.size, quality };
  await tx("readwrite", s => s.put({ ...meta, blob, thumb }));
  return meta;
}

export const getOffline = (id) => tx("readonly", s => s.get(id));
export const listOffline = () => tx("readonly", s => s.getAll());
export const removeOffline = (id) => tx("readwrite", s => s.delete(id));
